module.exports = __webpack_public_path__ + "static/media/alp.8904085e.png";